import React from "react";

const NAV = [
  { label: "Projeler", id: "work" },
  { label: "Yetenekler", id: "capabilities", secondary: true },
  { label: "Hakkımda", id: "profile", secondary: true },
  { label: "İletişim", id: "contact" },
];

const Header = ({ solid, onNavigate }) => (
  <header className="site-header" data-solid={solid ? "true" : "false"}>
    <button
      type="button"
      className="site-header__mark"
      onClick={() => onNavigate("top")}
      aria-label="Başa dön"
    >
      MT
    </button>
    <nav className="site-header__nav" aria-label="Bölümler">
      {NAV.map((item) => (
        <button
          type="button"
          key={item.id}
          className="site-header__link"
          data-secondary={item.secondary ? "true" : undefined}
          onClick={() => onNavigate(item.id)}
        >
          {item.label}
        </button>
      ))}
    </nav>
  </header>
);

export default Header;
